import React, {Component, PropTypes} from 'react';
import ReactBurgerMenu from 'react-burger-menu';
import {Link} from 'react-router';
import ga from 'react-ga';

const Menu = ReactBurgerMenu.slide;

if (typeof document !== 'undefined') {
    require('styles/main.scss')
}

export default class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {menuOpen: false};
        if (typeof window !== 'undefined') {
            ga.initialize('UA-64198624-1');
        }
    }

    handleMenuStateChange = ({isOpen}) => {
        this.setState({menuOpen: isOpen});
    };

    handleLinkClick = () => {
        this.setState({menuOpen: false});
    };

    render() {
        const {menuOpen} = this.state;

        return (
            <div id="layout">
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/layout.js